import IconInfo from '@apollo/icons/small/IconInfo.svg';
import { Switch } from '@apollo/orbit';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import { useTrackCustomEvent } from 'src/hooks/useTrackCustomEvent';
import { EventCategory } from 'src/lib/analytics';

export const UseGraphSettingsButton = ({
  label,
  tooltipContent,
  isSelected,
  disabled,
  className,
  onChange,
  trackingEventCategory,
}: {
  label: string;
  isSelected: boolean;
  tooltipContent?: string;
  disabled?: boolean;
  className?: string;
  onChange: (value: boolean) => void;
  trackingEventCategory?: EventCategory;
}) => {
  const trackCustomEvent = useTrackCustomEvent();
  return (
    <div
      className={className}
      {...(trackingEventCategory
        ? {
            onClick: () => {
              trackCustomEvent({
                action: 'interacted_with_override_graph_settings_button',
                category: trackingEventCategory,
              });
            },
          }
        : {})}
    >
      <div className="flex w-fit items-center">
        <Switch
          isChecked={isSelected}
          onChange={(e) => onChange(e.target.checked)}
          isDisabled={disabled}
        >
          {tooltipContent ? (
            <Tooltip label={tooltipContent}>
              <IconInfo className="mr-2 text-placeholder" />
            </Tooltip>
          ) : null}
          {label}
        </Switch>
      </div>
    </div>
  );
};
